// extracted by mini-css-extract-plugin
module.exports = {"box":"header_box__IrFv5"};